/* global eventDelegate:true */
/* global MNTK:true */

import queryString from 'query-string';
import validateEmail from '../functions/validate-email';

const { setCookie, getCookie, getEscapedCookie } = MNTK.cookieParse;
const COOKIE_NAME = 'subscriptionModalNeedShow';
const EMAIL_COOKIE = 'subscriptionEmail';

// первый показ лид-магнита на 7-ой секунде
const TIMEOUT = 7000;
// повторный показ лид-магнита на 70-ой секунде
const NEXT_TIMEOUT = TIMEOUT * 10;

const EVENTS = {
    SHOW: 'LEAD_MAGNET_SHOW',
    UNBLOCK_CLICK: 'LEAD_MAGNET_UNBLOCK_CLICK',
    SUBSCRIBED: 'LEAD_MAGNET_SUBSCRIBED',
    AGAIN_EMAIL: 'LEAD_MAGNET_AGAIN_EMAIL'
};

class LeadMagnet {
    constructor(context) {
        if (!context) {
            console.error('no context for lead magnet!');
            return;
        }

        if (getEscapedCookie('LeadMagnetMindBox')) {
            return;
        }

        // выходим, если пришли по рекламе яндекса, их обязательное требование: без всплывающих окон!
        const { ymclid } = queryString.parse(location.search);
        if (ymclid) {
            setCookie(COOKIE_NAME, '0', 30);
            this.destroyLead();
            return;
        }

        this.context = context;

        this.form = context.querySelector('.form');
        this.input = context.querySelector('input[type="email"]');
        this.submitBtn = context.querySelector('[data-submit]');
        this.error = context.querySelector('.error');
        this.showButton = context.querySelector('.lead-magnet');

        this.headerText = context.querySelector('#lead-header-text');
        this.secondText = context.querySelector('#lead-second-text');
        this.leadImage = context.querySelector('#lead-image');
        this.leadButtonCancel = context.querySelector('#lead-button-cancel');
        this.giftText = context.querySelector('#lead-gift-text');

        this.bindEvents();

        if (getCookie(COOKIE_NAME) !== '0') {
            let timeout = setTimeout(() => {
                this.showLead();
                clearTimeout(timeout);
                timeout = null;
            }, TIMEOUT);

            this.nextTimeout = setTimeout(() => {
                this.showLeadOneMoreTime();
            }, NEXT_TIMEOUT);
        }
    }

    bindEvents() {
        const handleInput = e => {
            this.showError(!e.target.value);
        };

        const handleChange = e => {
            this.showError(!validateEmail(e.target.value));
        };

        const handleSubmit = e => {
            e.preventDefault();
            const attr = 'data-submit';
            const emailUnlocked = e.target.getAttribute(attr) === 'true';
            e.target.setAttribute(attr, 'true');
            this.submitForm(emailUnlocked);
        };

        const handleShowButtonClick = () => {
            this.showLead(true);
        };

        this.input?.addEventListener('input', handleInput);
        this.input?.addEventListener('change', handleChange);
        this.submitBtn?.addEventListener('click', handleSubmit);
        this.showButton?.addEventListener('click', handleShowButtonClick);
    }

    showError(condition) {
        this.error.classList.toggle('visible', condition);
        this.input.classList.toggle('js-invalid', condition);
    }

    submitForm(emailUnlocked) {
        const email = this.input.value;

        // показываем поле ввода e-mail после клика на кнопку
        if (!emailUnlocked) {
            this.headerText?.classList.toggle('hidden');
            this.secondText?.classList.toggle('hidden');
            this.leadButtonCancel?.classList.toggle('hidden');
            this.leadImage.style.width = '40%';
            this.giftText?.classList.toggle('hidden');

            this.form?.classList.remove('d-none');
            this.input?.focus();

            this.trackLeadEvent(EVENTS.UNBLOCK_CLICK);
            return;
        }

        if (!validateEmail(email)) {
            this.showError(true);
            return;
        }

        window.togglePreloader();

        const url = Routing.generate('api.web.lead_magnet.mindbox', { email: email, lotId: this.context.dataset.lotId });
        MNTK.fetchJson(url, { method: 'POST' })
            .then(({ json }) => {
                const { message, newEmailObtained } = json;

                this.leadMagnetSubscribeSuccess(email, newEmailObtained);

                window.togglePreloader();
                window.onModalClose();
                window.openMessageModal(message);

                // убираем лид-магнит из DOM
                this.destroyLead();
            })
            .catch(error => this.handleError(error));
    }

    leadMagnetSubscribeSuccess(email, newEmailObtained) {
        setCookie(EMAIL_COOKIE, email, 30);
        // аналитика
        this.trackLeadEvent(EVENTS.SUBSCRIBED);
        newEmailObtained && MNTK.emit('NEW_EMAIL_OBTAINED');
        // Повторный показ лид-магнита. Учтем, что счетчик мы уже увеличили.
        this.viewCounter > 1 && this.trackLeadEvent(EVENTS.AGAIN_EMAIL);
    }

    showLead(showHard) {
        if (this.context?.classList.contains('hidden')) {
            this.destroyLead();
            return;
        }

        const openLeadModal = () => {
            if (!this.anotherModalIsOpened) {
                window.openModal('lead');

                setCookie(COOKIE_NAME, '0', 30);
                this.trackLeadEvent(EVENTS.SHOW);
                this.incrementViewCounter();

                if (!MNTK.cookieParse.getCookie('LeadMagnetMindBox')) {
                    MNTK.cookieParse.setCookie('LeadMagnetMindBox', 0, 30);
                }
            }
        };

        // иногда бывает такое, что модальное окно уже открыто и лид-магнит выскакивает невовремя
        if (!this.anotherModalIsOpened) {
            openLeadModal();
        } else {
            // если есть открытое окно, каждую секунду проверяем, можно ли показывать лид-магнит
            let int = null;
            int = setInterval(() => {
                openLeadModal();
                clearInterval(int);
                int = null;
            }, 1000);
        }
    }

    trackLeadEvent(event) {
        MNTK.stat?.onReady(() => {
            gtag('event', 'Click', {
                'event_category': event,
                'event_label': 'No',
                'non_interaction': false
            });

            MNTK.stat.trackYm('reachGoal', event);
            // MNTK.stat.trackVk('Event', event);
            window._tmr?.push({ type: 'reachGoal', id: MNTK.stat.top_mail_ru_code, goal: event});

            console.log('Lead magnet track', event);
        });
    }

    incrementViewCounter() {
        if (!window.localStorage) {
            return;
        }

        const count = this.viewCounter;
        localStorage.setItem('LEAD_MAGNET_SHOWN_TIMES', `${count + 1}`);
    }

    /**
     * @description Определяет, сколько раз лид-магнит показывался ранее
     * @return {number}
     */
    get viewCounter() {
        if (!window.localStorage) {
            return 0;
        }

        return Number(localStorage.getItem('LEAD_MAGNET_SHOWN_TIMES') || 0);
    }

    destroyLead() {
        this.context?.parentNode?.removeChild(this.context);
    }

    /**
     * @description Определяет, есть ли в данный момент открытое модальное окно
     * @return {boolean}
     */
    get anotherModalIsOpened() {
        return document.body.classList.contains('openModal');
    }

    showLeadOneMoreTime() {
        // лид-магнит мог быть удален из DOM
        if (document.getElementById('lead-magnet')) {
            return;
        }

        // нужно проверить, что не появилась кука с email
        if (getCookie(EMAIL_COOKIE)) {
            return;
        }

        // заменить предложение в лид-магните
        // const $title = this.context.querySelector('h2');
        // const $image = this.context.querySelector('img');
        //
        // $title.innerHTML = MNTK.nextLeadMagnet.title;
        // $image.setAttribute('src', MNTK.nextLeadMagnet.images['1x']);
        // $image.setAttribute(
        //     'srcset',
        //     `${MNTK.nextLeadMagnet.images['1x']} 1x, ${MNTK.nextLeadMagnet.images['2x']} 2x`
        // );
        // this.form.classList.add('d-none');
        // this.submitBtn.setAttribute('data-submit', 'false');
        // this.submitBtn.innerHTML = MNTK.nextLeadMagnet.btnText;

        const openLeadModal = () => {
            // показать лид-магнит еще раз, но с другим предложением
            this.showLead();

            // очистить таймаут
            clearTimeout(this.nextTimeout);
            this.nextTimeout = null;
        };

        if (!this.anotherModalIsOpened) {
            openLeadModal();
        } else {
            let int = null;
            int = setInterval(() => {
                openLeadModal();
                clearInterval(int);
                int = null;
            }, 1000);
        }
    }

    handleError(error) {
        const {
            xhr: { response, responseText }
        } = error;
        window.togglePreloader();
        window.onModalClose();
        window.openMessageModal(
            response || responseText || '',
            'Произошла ошибка!'
        );
        console.error(error);
    }
}

function initLeadMagnet() {
    console.log('Init lead magnet')
    window.MNTK.leadMagnet = new LeadMagnet(
        document.getElementById('lead-magnet')
    );
}

if ('requestIdleCallback' in window) {
    window.requestIdleCallback(initLeadMagnet);
} else {
    const leadMagnetTimeout = setTimeout(function () {
        initLeadMagnet();
        clearTimeout(leadMagnetTimeout);
    }, 0);
}
